/* global angular */
import '../../../assets/inspinia/plugins/metisMenu/jquery.metisMenu';

export default function($timeout) {
  'ngInject';

  return {
    restrict: 'A',
    link: function(scope, element) {
      polyFillCloset(element);

      // Call the metsiMenu plugin and plug it to sidebar navigation
      $timeout(function() {
        element.metisMenu();
      });

      // Collapse menu in mobile mode after click on a link with an href
      element.click(function(e) {
        const targetLink = e.target.closest('a[href]');

        if ($(window).width() < 769 && targetLink) {
          $('body').toggleClass('mini-navbar');
        }
      });

      // Enable initial fixed sidebar
      if ($('body').hasClass('fixed-sidebar')) {
        const sidebar = element.parent();
        sidebar.slimScroll({
          height: '100%',
          railOpacity: 0.9
        });
      }
    }
  };
}

function polyFillCloset(Element) {
  if (!Element || !Element.prototype) return;

  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }

  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;

      do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/sideNavigation/index.js